import store from "@/utils/store";
export default {
    token: store.get('token') || null, // 用户Token
    currentUserId: store.get('userId') || null,
    currentUser: null,
    money: parseFloat(store.get('money')) || 0, // 修复：转换为数字类型
    activeList: parseInt(store.get('activeList'), 10) || 0, // 修复：转换为整数
    group_id: parseInt(store.get('group_id'), 10) || null, // 修复：转换为整数，是否游客
    usercrud: store.get('idcard') || null,
}